import { type Locale } from './language'

/**
 * Gets cart ID local storage key.
 */
export const getShopifyCartIdStorageKey = (locale: Locale) =>
  `cart_id_${locale}_v2`
